import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LeftOutlined,
  PlusCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import {
  Tooltip,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  Space,
  Divider,
  Button,
  Modal,
  Descriptions,
  Spin,
} from "antd";

//OTHER IMPORTS
import dayjs from "dayjs";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from "../../../../../../components/custom/CustomButton";
import styles from "../../../../../../assets/styles/styles";

const { Text, Title } = Typography;

const CreateGuarantor = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();

  // const existingClientCheck = Form.useWatch("existingClient", form);
  const [existingClient, setExistingClient] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCustomerSelected, setIsCustomerSelected] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [membersList, setMembersList] = useState([]);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const [payloadData, setPayloadData] = useState([]);
  const [entityId, setEntityId] = useState(0);
  const [currentCustomerDetails, setCurrentCustomerDetails] = useState({});
  const [officeId, setOfficeId] = useState("");
  const [guarantorTypeId, setGuarantorTypeId] = useState(1);
  const [guarantorTemplate, setGuarantorTemplate] = useState([]);

  useEffect(() => {
    getClientTemplate();
    getGuarantorsTemplate();
  }, []);

  function getClientTemplate() {
    const url = `${apiConfig.Clients}/template`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;

        const tempOfficeOptions = [];

        objList?.officeOptions?.forEach((element) =>
          tempOfficeOptions.push({
            label: element?.name,
            value: element?.id,
          })
        );

        setOfficeOptions(tempOfficeOptions);

        form.setFieldsValue({
          existingClient: true,
          branch: objList?.officeOptions[0].id,
        });
      }
    });
  }
  function getGuarantorsTemplate() {
    const url = `${apiConfig.Loans}/${state.id}/guarantors/template`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        setGuarantorTemplate(res);

        const tempRelationshipOptions = [];

        objList?.allowedClientRelationshipTypes?.forEach((element) =>
          tempRelationshipOptions.push({
            label: element?.name,
            value: element?.id,
          })
        );

        setRelationshipOptions(tempRelationshipOptions);
      }
    });
  }
  function onCancel() {
    navigate("/detail-group-loan", { state: state });
  }
  function handleOfficeChange(idParam) {
    setOfficeId(idParam);
    const url = `${apiConfig.Clients}/template`;
    const params = {
      officeId: idParam,
    };
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors);
      } else {
        setIsLoading(false);
        const objList = res;
      }
    });
  }
  const handleExistingClient = (value) => {
    setExistingClient(value);
    if (value) {
      setGuarantorTypeId(
        guarantorTemplate?.guarantorTypeOptions.find(
          (item) => item.value.toLowerCase() === "customer"
        )?.id
      );
      console.log("When Customer and existing Client", guarantorTypeId);
    } else {
      setGuarantorTypeId(
        guarantorTemplate?.guarantorTypeOptions.find(
          (item) => item.value.toLowerCase() === "external"
        )?.id
      );
      console.log("When External and non-existing Client", guarantorTypeId);
    }
  };

  const items = [
    {
      key: "1",
      label: labelConfig.id,
      children: customerDetails ? currentCustomerDetails.id : "-",
      span: 3,
    },
    {
      key: "2",
      label: labelConfig.name,
      children: customerDetails ? currentCustomerDetails.name : "-",
      span: 3,
    },
    {
      key: "3",
      label: labelConfig.office,
      children: customerDetails ? currentCustomerDetails.office : "-",
      span: 3,
    },
    {
      key: "4",
      label: labelConfig.activationDate,
      children: customerDetails
        ? BOM.DateTime(currentCustomerDetails.activationDate, "only-date")
        : "-",
      span: 3,
    },
  ];

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Loans}/${state.id}/guarantors`;

    formValues.dob = formValues.dob
      ? BOM.DateTime(formValues.dob, "only-date")
      : formValues.dob;
    const dateFormat =
      formValues.dob === BOM.DateTime(formValues.dob, "only-date")
        ? "dd MMMM yyyy"
        : undefined;
    delete formValues.existingClient;
    delete formValues.branch;
    formValues.guarantorTypeId = guarantorTypeId;
    if (existingClient) {
      formValues.entityId = entityId;
    }

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat,
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.createGuarantorMsg);
        navigate("/detail-group-loan", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.createGuarantor}
        pageItems={staticConfig.createGuarantorBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.existingClient}
                  name="existingClient"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.option}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handleExistingClient}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.office}
                  name="branch"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.office),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.office,
                      "select"
                    )}
                    options={officeOptions}
                    showSearch
                    onChange={handleOfficeChange}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.relationship}
                  name={"clientRelationshipTypeId"}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.relationship,
                      "select"
                    )}
                    options={relationshipOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>

              {!existingClient && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text>{labelConfig.firstName}</Text>}
                      name={"firstname"}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text>{labelConfig.lastName}</Text>}
                      name={"lastname"}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.dateOfBirth} name={"dob"}>
                      <DatePicker
                        placeholder={BOM.handlePlaceholderMsg(
                          `${labelConfig.dateOfBirth}`,
                          "select"
                        )}
                        style={{
                          width: "100%",
                          height: 35,
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.addressOne}
                      name={"addressLine1"}
                    >
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.addressTwo}
                      name={"addressLine2"}
                    >
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.city} name={"city"}>
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.zip} name={"zip"}>
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.mobileNumber}
                      name={"mobileNumber"}
                    >
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.residence}
                      name={"housePhoneNumber"}
                    >
                      <Input placeholder="Please enter a value" />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>

            {existingClient && (
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.guarantorInfo}
                  </Title>
                </Divider>

                <GuarantorSearchModal
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  setGuarantorTypeId={setGuarantorTypeId}
                  setMembersList={setMembersList}
                  setEntityId={setEntityId}
                  state={state}
                  membersList={membersList}
                  session={session}
                  officeId={officeId}
                  isCustomerSelected={isCustomerSelected}
                  setIsCustomerSelected={setIsCustomerSelected}
                  setPayloadData={setPayloadData}
                  payloadData={payloadData}
                  items={items}
                  customerDetails={customerDetails}
                  setCustomerDetails={setCustomerDetails}
                  currentCustomerDetails={currentCustomerDetails}
                  setCurrentCustomerDetails={setCurrentCustomerDetails}
                />
              </Row>
            )}

            <Row>
              {isCustomerSelected && (
                <Descriptions
                  bordered
                  column={{
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 2,
                    xxl: 2,
                  }}
                  style={{ marginTop: 10, marginBottom: 20, width: 510 }}
                  items={items}
                />
              )}
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_GUARANTOR") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default CreateGuarantor;

const GuarantorSearchModal = (props) => {
  const {
    session,
    setMembersList,
    membersList,
    isModalOpen,
    setIsModalOpen,
    setEntityId,
    officeId,
    isCustomerSelected,
    setIsCustomerSelected,
    setPayloadData,
    payloadData,
    state,
    items,
    customerDetails,
    setCustomerDetails,
    setGuarantorTypeId,
    setCurrentCustomerDetails,
  } = props;

  const [useForm] = Form.useForm();
  const [customerData, setCustomerData] = useState([]);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }
    setSearchParam(searchKey);
  }

  const onSearch = (officeId) => {
    setIsCustomerSelected(false);
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }

    const params = {
      displayName: searchParam.trim(),
      officeId: officeId ? officeId : null,
      orderBy: "displayName",
      sortOrder: "ASC",
    };

    const url = `${apiConfig.Clients}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    // return
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempCustomerData = [];
        let tempCustomerDetails = [];

        objList?.forEach((element) => {
          tempCustomerData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.forEach((element) => {
          tempCustomerDetails.push({
            key: element.id,
            id: element.id,
            name: element.displayName,
            office: element.officeName,
            clientId: element.id,
            activationDate: element.activationDate,
          });
        });

        if (tempCustomerData === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerData(tempCustomerData);
        setCustomerDetails(tempCustomerDetails);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCustomerSave = (formValues) => {
    const newCustomer = customerDetails?.find(
      (item) => item.id === formValues.customerId
    );

    let foundCharge = membersList.find((item) => item.id === newCustomer?.id);
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
      return;
    }
    setMembersList([...membersList, newCustomer]);
    setPayloadData([...payloadData, newCustomer]);
    useForm.resetFields();
  };

  const onChangeCustomer = (customerParam) => {
    const currentCustomerDetails = customerDetails?.find(
      (item) => item.id === customerParam
    );
    getGuarantorsDetails(customerParam);
    setCurrentCustomerDetails(currentCustomerDetails);
    setEntityId(customerParam);
    setIsCustomerSelected(true);
  };

  function getGuarantorsDetails(customerParam) {
    const url = `${apiConfig.Loans}/${state.id}/guarantors/accounts/template/`;
    const params = {
      clientId: customerParam,
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false);
        const objDetail = res;
      }
    });
  }

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
      >
        {labelConfig.addGuarantor}
      </Button>

      <Modal
        title="Search For a Guarantor"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onOk={handleCancel}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleCustomerSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Space.Compact>
                <div>
                  <Input
                    onChange={handleSearchInTable}
                    placeholder="Search by Customer Name"
                    style={{ width: 460 }}
                    allowClear
                  />
                </div>
                <Button
                  type="primary"
                  className="of-primaryBtnColor"
                  onClick={() => onSearch(officeId)}
                >
                  <SearchOutlined />
                </Button>
              </Space.Compact>
            </Col>
          </Row>
          {showDetailsForm && (
            <>
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.selectGuarantor}
                  </Title>
                </Divider>
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.name}
                    name={"entityId"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.name),
                      },
                    ]}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.name,
                        "select"
                      )}
                      options={customerData}
                      showSearch
                      onChange={onChangeCustomer}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {isCustomerSelected && (
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />
          )}
        </Spin>
      </Modal>
    </Row>
  );
};
